import {Injectable, Injector} from '@angular/core';
import {EntityManagerStateService, State} from './entity-manager-state.service';
import {EntityManagerConfigurator} from '../entity-manager.configurator';
import {forkJoin, Observable, of} from 'rxjs';

export enum EventType {
  PreCreate = 1,
  PreUpdate = 2,
  PreDelete = 3,

  PreRemove = 4,
  PrePersist = 5
}

@Injectable({
  providedIn: 'root'
})
export class EntityManagerEventService {

  private configuration;

  private eventMapping: any = {};

  public constructor(
    private injector: Injector,
    private state: EntityManagerStateService
  ) {
    this.configuration = this.injector.get<EntityManagerConfigurator>(EntityManagerConfigurator);
    this.createMapping();
  }

  public run(entity: any, eventType: EventType) {
    const listenersTypes = this.configuration.providers || [];

    for (const listenerType of listenersTypes) {
      const listener = this.injector.get(listenerType);

      const methodName = this.createEventMethodName(eventType);

      if (typeof listener[methodName] === 'function') {
        listener[methodName](entity);
      }
    }
  }

  public runPreFlush(entity: any = null): EntityManagerEventService {
    if (entity === null) {
      this.runPreFlushEvents();
    } else if (entity instanceof Array) {
      for (const e of entity) {
        this.runPreFlushEvent(e);
      }
    } else {
      this.runPreFlushEvent(entity);
    }

    return this;
  }

  private runPreFlushEvents(): EntityManagerEventService {
    for (const entity of this.state.getEntities(State.Create)) {
      this.run(entity, EventType.PreCreate);
    }

    for (const entity of this.state.getEntities(State.Update)) {
      this.run(entity, EventType.PreUpdate);
    }

    for (const entity of this.state.getEntities(State.Delete)) {
      this.run(entity, EventType.PreDelete);
    }

    return this;
  }

  private runPreFlushEvent(entity: any): EntityManagerEventService {
    const state = this.state.getEntityState(entity);

    if (state === State.Create) {
      this.run(entity, EventType.PreCreate);
    }

    if (state === State.Update) {
      this.run(entity, EventType.PreUpdate);
    }

    if (state === State.Delete) {
      this.run(entity, EventType.PreDelete);
    }

    return this;
  }

  private createMapping(): void {
    this.eventMapping[EventType.PreCreate] = 'prePost';
    this.eventMapping[EventType.PreUpdate] = 'prePut';
    this.eventMapping[EventType.PreDelete] = 'preDelete';
    this.eventMapping[EventType.PreRemove] = 'preRemove';
    this.eventMapping[EventType.PrePersist] = 'prePersist';
  }

  private createEventMethodName(eventType: EventType): string {
    const methodPrefix = 'on',
      methodName = this.eventMapping[eventType];

    return methodPrefix + methodName[0].toUpperCase() + methodName.slice(1);
  }
}
